"use client";

import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

export default function ServicesHero() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start start", "end start"]
  });

  const y = useTransform(scrollYProgress, [0, 1], ["0%", "30%"]);
  const opacity = useTransform(scrollYProgress, [0, 0.5], [1, 0]);

  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] }
  };

  const staggerContainer = {
    animate: {
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  return (
    <section
      ref={sectionRef}
      className="pt-32 pb-20 relative overflow-hidden bg-dark-bg"
    >
      <motion.div 
        className="absolute inset-0 pointer-events-none" 
        style={{ 
          y, 
          opacity,
          background: "radial-gradient(ellipse 70% 60% at 50% 0%, rgba(75, 0, 130, 0.15) 0%, rgba(106, 13, 173, 0.1) 40%, transparent 70%)"
        }}
      />
      <motion.div 
        className="max-w-4xl mx-auto px-6 text-center relative z-10"
        variants={staggerContainer}
        initial="initial"
        animate="animate"
      >
        <motion.span variants={fadeInUp} className="section-label mb-6 inline-flex">Full-Stack Logistics</motion.span>
        <motion.h1
          variants={fadeInUp}
          className="font-heading font-extrabold text-text-primary mb-6"
          style={{ fontSize: "clamp(36px, 5vw, 64px)", letterSpacing: "-0.025em", lineHeight: "1.1" }}
        >
          One partner.{" "}
          <span className="gradient-text">Every step.</span>
        </motion.h1>
        <motion.p variants={fadeInUp} className="text-xl text-text-secondary max-w-2xl mx-auto leading-relaxed">
          From factory floor to your customer's door — Helium manages every logistics touchpoint so you can focus on growing your brand.
        </motion.p>
      </motion.div>
    </section>
  );
}